import { AdminTopBarNavMenuFrame } from '@/imports/ui/admin/layouts/AdminTopBarNavMenuFrame';
import { FinancialsPage } from '@/imports/ui/admin/pages/FinancialsPage/FinancialsPage';
import { OtherItemsCategoryPage } from '@/imports/ui/admin/pages/FinancialsPage/OtherItemsCategoryPage';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

const OtherItemsListPage = () => {
  return (
    <AdminTopBarNavMenuFrame>
      <FinancialsPage title="Other Items Category">
        <OtherItemsCategoryPage />
      </FinancialsPage>
    </AdminTopBarNavMenuFrame>
  );
};

export default restrictedRoute(
  OtherItemsListPage,
  { requiresEvery: [RouteRestrictions.ADMIN_ROLE] },
);
